<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <period-select v-model="filter.period_id" @change="onFilter" />
      </div>
      <datatable
        :columns="tableColumns"
        :total="offices.meta.page.total"
        :perPage="offices.meta.page.perPage"
        :currentPage="offices.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #add-thead="{ classes }">
          <tr>
            <td :class="[classes.th, 'text-right']">Debit</td>
            <td :class="[classes.th, 'text-right']">Kredit</td>
            <td :class="[classes.th, 'text-right']">Saldo</td>
            <td :class="[classes.th, 'text-right']">Debit</td>
            <td :class="[classes.th, 'text-right']">Kredit</td>
            <td :class="[classes.th, 'text-right']">Saldo</td>
            <td :class="[classes.th, 'text-right']">Debit</td>
            <td :class="[classes.th, 'text-right']">Kredit</td>
            <td :class="[classes.th, 'text-right']">Saldo</td>
            <td :class="[classes.th, 'text-right']">Debit</td>
            <td :class="[classes.th, 'text-right']">Kredit</td>
            <td :class="[classes.th, 'text-right']">Saldo</td>
            <td :class="[classes.th, 'text-right']">Debit</td>
            <td :class="[classes.th, 'text-right']">Kredit</td>
            <td :class="[classes.th, 'text-right']">Saldo</td>
          </tr>
        </template>
        <template #tbody="{ classes }">
          <tr
            v-for="office in offices.data"
            :key="office.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">
              {{ office.attributes.code }}
            </td>
            <td :class="classes.td">
              {{ office.attributes.name }}
            </td>
            <template v-if="officeSummaries && officeSummaries[office.id]">
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_restock_balance
                    ?.total_order_price | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_restock_balance
                    ?.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_restock_balance?.balance
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_overpayment_balance
                    ?.total_order_price | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_overpayment_balance
                    ?.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_overpayment_balance?.balance
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_debt_balance?.total_order_price
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_debt_balance
                    ?.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_debt_balance?.balance
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_deposit_balance
                    ?.total_order_price | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_deposit_balance
                    ?.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.sc_deposit_balance?.balance
                    | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.multiplied_sc_deposit_balance
                    ?.total_order_price | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.multiplied_sc_deposit_balance
                    ?.total_payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  officeSummaries[office.id]?.multiplied_sc_deposit_balance
                    ?.balance | toCurrency
                }}
              </td>
            </template>
            <td v-else colspan="15"></td>
          </tr>

          <tr v-if="offices.data.length && periodSummary">
            <td></td>
            <td :class="[classes.td, 'text-right']">Total</td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_restock_balance?.total_order_price | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_restock_balance?.total_payment_amount
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ periodSummary.sc_restock_balance?.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_overpayment_balance?.total_order_price
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_overpayment_balance?.total_payment_amount
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ periodSummary.sc_overpayment_balance?.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ periodSummary.sc_debt_balance?.total_order_price | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_debt_balance?.total_payment_amount | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ periodSummary.sc_debt_balance?.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_deposit_balance?.total_order_price | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.sc_deposit_balance?.total_payment_amount
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ periodSummary.sc_deposit_balance?.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.multiplied_sc_deposit_balance?.total_order_price
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.multiplied_sc_deposit_balance?.total_payment_amount
                  | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                periodSummary.multiplied_sc_deposit_balance?.balance | toCurrency
              }}
            </td>
          </tr>
        </template>
      </datatable>
    </div>
  </base-wrapper>
</template>

<script>
import PeriodSelect from '@/components/period/period-select.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  mixins: [requestMixin],
  components: { PeriodSelect },
  data() {
    return {
      currentPeriod: {
        data: {
          attributes: {},
        },
      },
      filter: {
        period_id: null,
      },
      loadingBalanceSummaries: false,
      loadingCurentPeriod: false,
      offices: {
        data: [],
        meta: {
          page: {},
        },
      },
      officeSummaries: null,
      periodSummary: null,
    };
  },
  computed: {
    loading() {
      return this.loadingCurentPeriod || this.loadingBalanceSummaries;
    },
    tableColumns() {
      return [
        {
          id: 'office_code',
          name: 'Stockist',
          rowspan: 2,
        },
        {
          id: 'office_name',
          name: 'Pengelola Stockist',
          rowspan: 2,
        },
        {
          id: 'restock',
          name: 'Restock',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'overpayment',
          name: 'Sisa Bayar',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'debt',
          name: 'Kurang Bayar',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'deposit',
          name: 'Deposit',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'multiplied_deposit',
          name: 'Nilai Deposit',
          colspan: 3,
          theadClass: 'text-center',
        },
      ];
    },
  },
  methods: {
    async loadCurrentPeriod() {
      this.loadingCurentPeriod = true;

      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.currentPeriod = res;

        this.filter.period_id = res.data.id;
      }

      this.loadingCurentPeriod = false;
    },
    async loadBalanceSummaries(params) {
      this.loadingBalanceSummaries = true;

      const [offices, err] = await this.request('/api/v1/offices', {
        params: {
          'filter[office_category_id]': 3,
          'page[size]': 10,
          'fields[simple-offices]': 'code,name,office_id',
          'pagination[type]': 'default',
          sort: '-updatedAt',
          ...params,
        },
      });

      if (!err) {
        this.offices = offices;

        const [summaries, err] = await this.request(
          `/api/v1/office-balance-summaries/-actions/get-by-office-id-summaries`,
          {
            params: {
              'filter[office_id_in]': offices.data
                .map((office) => office.attributes.office_id)
                .join(','),
              'filter[period_id]': this.filter.period_id,
            },
          }
        );

        if (!err) {
          this.officeSummaries = summaries.office;
          this.periodSummary = summaries.period;
        }
      }

      this.loadingBalanceSummaries = false;
    },
    onChangePage(page) {
      this.loadBalanceSummaries({
        'page[number]': page,
      });
    },
    onFilter() {
      this.loadBalanceSummaries();
    },
  },
  async created() {
    await this.loadCurrentPeriod();
    this.loadBalanceSummaries();
  },
};
</script>
